import type { SharedConversationMessage } from "../api/sharing";
import { messageAttachmentViews } from "../lib/attachments";
import { AssistantMessage } from "./AssistantMessage";
import { UserMessage } from "./UserMessage";

/**
 * Read-only transcript of a shared conversation. Reuses the turn components but
 * drops every interactive affordance (no run controls, regenerate, fork, branch
 * switcher, or editing) — it's a static snapshot.
 */
export function SharedThread({ messages }: { messages: SharedConversationMessage[] }) {
  return (
    <div className="mx-auto w-full max-w-[760px] px-6 pb-16 pt-4 max-[880px]:px-4">
      {messages.map((message) =>
        message.role === "user" ? (
          <UserMessage
            key={message.id}
            content={message.content}
            attachments={messageAttachmentViews(message.attachments)}
          />
        ) : (
          <AssistantMessage
            key={message.id}
            content={message.content}
            messageId={message.id}
            sources={message.sources}
          />
        ),
      )}
    </div>
  );
}
